export const ResetPassword = {
	title: "Återställ lösenord",
	explanation: "Ange ditt nya lösenord nedan för att återställa ditt kontolösenord.",
	repeat_password_label: "Upprepa lösenord",
	button_text: "Återställ lösenord",
	loading_button_text: "Återställer...",
	remember_password_text: "Kommer du ihåg ditt lösenord?",
	login_button_text: "Logga in",
	success_title: "Lösenord återställt",
	success_explanation: "Ditt lösenord har återställts. Du kan nu logga in med ditt nya lösenord.",
};
